<template>
  <component :is="component" :state="state" />
</template>

<script>
export default {
  name: "App",
  props: ["component", "state"]
};
</script>
